var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgNameIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.119 9.295c-.045-.025-.096-.184-.003-.513.995-1.052 1.61-2.559 1.61-3.967C11.725 2.576 10.13 1 7.938 1 5.753 1 4.225 2.564 4.225 4.803c0 1.427.62 2.945 1.626 3.99.1.33-.03.448-.114.485C4.74 9.628 1 10.908 1 12.68V15h14V12.382c-.484-1.625-4.023-2.812-4.881-3.087Z",
  fillRule: "nonzero",
  stroke: "#979797",
  fill: "none"
})));

export default SvgNameIcon;